/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {EntryMetadata} from "./EntryMetadata";
import {List} from "ionic-angular";
/**
 * Created by andrea on 2017-06-24.
 */

export class AgeCategory extends EntryMetadata {

  public minAge: number;
  public maxAge: number;

  constructor(id: string, name: string, description: string, minAge: number, maxAge: number) {
    if (!description) {
      if (maxAge < minAge) {
        description = `Age ${minAge} and up`;
      } else if (minAge < maxAge) {
        description = `Between ${minAge} and ${maxAge} years`;
      } else {
        description = `Age ${minAge}`;
      }
    }

    super(id, name, description);

    this.minAge = minAge;
    this.maxAge = maxAge;
  }

  static listFromSnapshot(key: string, val: [{maxAge, minAge, name}]) {
    let items: Array<AgeCategory> = new Array();

    for (let id of Object.keys(val)) {
      items.push(new AgeCategory(id, val[id].name, val[id].description, val[id].minAge, val[id].maxAge));
    }

    return items;
  }

}



// WEBPACK FOOTER //
// ./src/models/schedule/metadata/AgeCategory.ts